import * as React from 'react'

import { Box, Icon, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useContractCues } from 'modules/contracts/lib/contractCuesContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import { IContractVersion } from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

import TooltipContent from './TooltipContent'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const MissingData = ({ contractVersion, employee }: Props) => {
  const [showTooltip, toggleTooltip] = useToggle(false)
  const contractCues = useContractCues()
  if (!contractCues.hasCues) return null

  const pendingRules = contractCues.incidenceRules.filter((rule) => {
    const fieldName = rule.attributes.field
    if (!(fieldName in contractVersion.attributes)) return false

    const field = contractVersion.attributes[fieldName as keyof IContractVersion]
    return field === null
  })

  if (pendingRules.length === 0) return null

  return (
    <Tooltip.ItemList attachment="bottom center" open={showTooltip} toggle={toggleTooltip}>
      <Tag type="radical" inline>
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Icon.Medium icon="alert-circle-line" color="radicalRed1200" />
          <Text.Normal capitalize weight="medium" size="200" color="grey1000">
            {i18n.t('contract_versions.header.tags.missing_data.title')}
          </Text.Normal>
        </Box>
      </Tag>
      <TooltipContent
        pendingRules={pendingRules}
        employeeId={employee.id.toString()}
        contractVersionId={contractVersion.id.toString()}
      />
    </Tooltip.ItemList>
  )
}

export default observer(MissingData)
